import React, { memo } from 'react'
import { WeekSelect } from '@app/components/alerts'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { ProfileInputCell } from '../general/cells/profile-input'
import { User } from '@app/types'
import { SwitchToggle } from '../general/switch-toggle'

type NotificationSettingsProps = {
  filterEmailDatesData: number[]
  onAlertToggle(): void
  onFilterEmailDates(dates: number[], morning: boolean): Promise<void>
  alertEnabled?: boolean
  defaultDayTime?: boolean
}

// stateless notification settings - TODO: move to client side detection of input or add loading
const NotificationSettingsComponent = ({
  onAlertToggle,
  onFilterEmailDates,
  filterEmailDatesData,
  alertEnabled,
  defaultDayTime,
  user,
  loading,
}: NotificationSettingsProps & {
  user?: User
  loading?: boolean
}) => {
  const { t } = useTranslation('settings')
  const { activeSubscription } = user ?? { activeSubscription: false }

  const disabled = !activeSubscription || [11, 20, 0].includes(user?.role || 0)

  return (
    <ProfileInputCell
      title={t('notifications')}
      subTitle={t('alert-t-details')}
      disabledWall={disabled}
      skeletonLoad={!user && loading}
      submitLabel={{
        disabled,
        title: `${t('notification-settings')}`,
      }}
    >
      <>
        <WeekSelect
          confirmDates={onFilterEmailDates}
          filterEmailDates={filterEmailDatesData}
          disabled={!alertEnabled}
          defaultDayTime={defaultDayTime}
        />
        <div className='pt-4'>
          {loading && !user ? (
            <span className='block min-h-[21px] w-20 bg-gray-300 dark:bg-gray-700' />
          ) : (
            <SwitchToggle
              id={'switch-toggle-notifications'}
              title={`${t('notifications')} ${t(
                alertEnabled ? 'enabled' : 'disabled'
              )}`}
              checked={alertEnabled}
              onChange={onAlertToggle}
              disabled={disabled}
            />
          )}
        </div>
      </>
    </ProfileInputCell>
  )
}

export const NotificationSettings = memo(NotificationSettingsComponent)
